<template>
    <b-container fluid>
        <div>
            <b-row>
                <b-col cols="12" class="py-2">
                    <label for="title">Nombre</label>
                    <b-form-input
                        type="text"
                        size="sm"
                        id="title"
                        v-model="theFileClient.name"
                        @input="$v.theFileClient.name.$touch()"
                        :valid="!$v.theFileClient.name.$error"
                    ></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" class="py-2">
                    <label for="reporter">Fecha de expiración</label>
                    <b-form-input
                        v-model="theFileClient.expiration"
                        type="date"
                        placeholder="Seleccione una fecha"
                    ></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" md="6" class="py-2">
                    <label for="type">Tipo de archivo</label>
                    <app-form-select-input
                        size="sm"
                        :options="fileTypes"
                        id="type"
                        v-model="theFileClient.fileTypeId"
                        @change="$v.theFileClient.fileTypeId.$touch()"
                        :valid="!$v.theFileClient.fileTypeId.$error"
                        required
                    ></app-form-select-input>
                </b-col>
                <b-col cols="12" md="6" class="py-2">
                    <label for="private">Archivo privado</label>
                    <b-form-checkbox
                        switch
                        id="private"
                        v-model="theFileClient.private"
                    ></b-form-checkbox>
                </b-col>
                <b-col cols="12">
                    <label for="description">Descripción</label>
                    <b-form-textarea
                        id="textarea"
                        v-model="theFileClient.description"
                        placeholder="ingrese alguna descripción..."
                        rows="3"
                        max-rows="6"
                    ></b-form-textarea>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" class="py-2">
                    <label v-if="editing" for="file">
                        <h4>Archivo actual: {{ currentFileName }}</h4>
                    </label>
                    <label v-else for="file">Archivo</label>
                    <b-form-file
                        id="file"
                        v-model="file"
                        required
                    ></b-form-file>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>

<script>
import {
    required,
    email,
    numeric,
    minLength,
    maxLength,
} from 'vuelidate/lib/validators'
export default {
    props: {
        onSave: {
            type: Function,
        },
    },

    data() {
        return {
            theFileClient: {
                name: '',
                fileTypeId: '',
                private: false,
                expiration: '',
                description: '',
            },
            file: null,
            clients: [],
            fileTypes: [],
            editing: false,
            currentFileName: '',
            clientFileId: '',
        }
    },
    validations: {
        theFileClient: {
            name: { required },
            fileTypeId: { required, numeric },
        },
    },
    methods: {
        async saveFile() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.warning(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }
            if (!this.file && !this.editing) {
                toastr.warning('Debe agregar un archivo')
            } else {
                const formData = new FormData()

                _.forIn(this.theFileClient, (value, key) => {
                    formData.append(key, value)
                })
                formData.append('file', this.file)
                formData.append('clientId', this.client.id)
                if (this.editing) {
                    formData.append('_method', 'PUT')
                }
                const { data } = !this.editing
                    ? await repo.post('file-management', formData)
                    : await repo.post(
                          `file-management/${this.clientFileId}`,
                          formData
                      )
                if (data.status) {
                    this.$emit('onSave', data)
                } else {
                    this.$emit('onError', data)
                }
            }
        },
        fillForm(file) {
            this.currentFileName = file.name
            this.editing = true
            this.clientFileId = file.id
            this.theFileClient.name = file.name
            this.theFileClient.fileTypeId = file.file_type.id
            this.theFileClient.private = file.private === 1 ? true : false
            this.theFileClient.expiration = file.expiration
            this.theFileClient.description = file.description
        },
        cleanForm() {
            Object.keys(this.theFileClient).map(
                key => (this.theFileClient[key] = '')
            )
            this.$nextTick(() => {
                this.$v.$reset()
            })
            this.editing = false
            this.file = null
        },
        async loadFileType() {
            const { data } = await repo.get(
                'file-management/file-types',
                null,
                'ocurrio un error al cargar los tipos de archivos'
            )
            this.fileTypes = data
        },
    },
    mounted() {
        this.loadFileType()
    },
}
</script>
